const YM_DISABLE_KEYS_CLASS_NAME = 'ym-disable-keys';

export function hideInputElementsForWebVisor(): void {
	document.querySelectorAll('input').forEach(input => {
		if (!input.classList.contains(YM_DISABLE_KEYS_CLASS_NAME)) {
			input.classList.add(YM_DISABLE_KEYS_CLASS_NAME);
		}
	});
}
